import React from 'react'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormInput from '../../../../library/form/components/FormInput';
import FormSearchButton from '../../../../library/form/components/FormSearchButton';
import FormAttachment from '../../../../library/form/components/FormAttachment';
import FormLink from '../../../../library/form/components/FormLink';
import FormWrapper from '../../../../library/form/components/FormWrapper'
import FormLabel from '../../../../library/form/components/FormLabel'
import FormSH from '../../../../library/form/components/FormSH';
import { UiGridColTwo, UiCol, UiRow } from "../../../../library/layout/Index";

import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormButton from '../../../../library/form/components/FormActionButton2';
import BudgetHeaderLocationWiseRow from './BudgetHeaderLocationWiseRow';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from '../../../../library/layout/Index';

const BudgetHeaderLocationWiseEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if (!viewData) return null;

    //Shared fields and totals use the sharedFields header row; view rows contain the workspace header and chained headers.
    //Server view generation and row actions will be integrated in the next step.

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ attachHeaderRow: "sharedFields", actionParam: { confirmHeader: "1" }, formActions: { forAction: 'Confirm', forCancel: 'Cancel' } }}
            formStyle={{ width: '950px', maxWidth: '95vw' }}
            formTitle={<FormTitle formObject={formObject} value="Order Sheet" />}
            formObject={formObject}>

            <UiGridColTwo>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "itemName" }} value="Target Item" />
                            </span>
                            <FormSearchButton formObject={formObject} headerKey='lineItemLink'
                                text={<SarasTrans value="Select Item" />} placeHolder="Barcode / Id..."
                                action={{ actionId: "refresh",  actionParam: {} }}
                                className='uiActionButton uiSpacerH5'
                            />
                        </li>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat3" }} value="" />
                            </span>
                            <FormInput formObject={formObject} headerKey="sharedFields" className="uiInput"
                                action={{ InputType: "ac", paramName: "cat3", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                            <FormSH formObject={formObject} headerKey="sharedFields"
                                action={{ actionId: "new", paramName: "cat3",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                            />
                        </li>
                    </ul>
                </UiCol>
            </UiGridColTwo>
            <UiRow>
                <ul>
                    <li>
                        <div className="uiInline uiSpacerH5">
                            <FormAttachment imgHeight="50px" formObject={formObject} headerKey="sharedFields" action={{ InputType: "i", paramName: "itemImage" }} />
                        </div>
                        <FormLink formObject={formObject} headerKey="sharedFields" linkProp={{ target: "_blank" }}
                            action={{ paramName: "itemName", actionId: "show", actionName: "itemComp" }}
                        />
                    </li>
                </ul>
            </UiRow>
            <UiGridColTwo>
                <UiCol>
                    <ul>
                        <FormWrapper customWrapper="li" formObject={formObject} headerKey="sharedFields" action={{ paramName: "bomName" }}>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "bomName" }} value="BOM" />
                            </span>
                            <FormInput formObject={formObject} headerKey="sharedFields" className="uiInput"
                                action={{ InputType: "ac", paramName: "bomName", acMethod: "TargetItemBom",
                                    acDepCtrl: { dparam: '%dataList.valLDT', tdtId: '%dataList.tdtId', tdId: '%dataList.tdId' } }} />
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat1" }} value="" />
                            </span>
                            <FormInput formObject={formObject} headerKey="sharedFields" className="uiInput"
                                action={{ InputType: "ac", paramName: "cat1", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat2" }} value="" />
                            </span>
                            <FormInput formObject={formObject} headerKey="sharedFields" className="uiInput"
                                action={{ InputType: "ac", paramName: "cat2", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "budgetDate" }} value="Budget Date" />
                            </span>
                            <FormInput formObject={formObject} headerKey="sharedFields" className="uiInput"
                                action={{ InputType: "dp", paramName: "budgetDate" }} />

                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} headerKey="sharedFields" action={{ paramName: "currency" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "currency" }} value="Currency" />
                            </span>
                            <FormInput formObject={formObject} headerKey="sharedFields" className="uiInput"
                                action={{ InputType: "ac", paramName: "currency", acMethod: "CurrencyName", acDepCtrl: { dparam: '%dataList.valLDT' } }} />
                        </FormWrapper>
                    </ul>
                </UiCol>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat4" }} value="" />
                            </span>
                            <FormInput formObject={formObject} headerKey="sharedFields" className="uiInput"
                                action={{ InputType: "ac", paramName: "cat4", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "cat5" }} value="" />
                            </span>
                            <FormInput formObject={formObject} headerKey="sharedFields" className="uiInput"
                                action={{ InputType: "ac", paramName: "cat5", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                            <FormSH formObject={formObject} headerKey="sharedFields"
                                action={{ actionId: "new", paramName: "cat5",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                 ></FormSH>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} headerKey="sharedFields" action={{ paramName: "profile" }} value="Profile" />
                            </span>
                            <FormInput formObject={formObject} headerKey="sharedFields" className="uiInput"
                                action={{
                                    InputType: "ac", paramName: "profile", acMethod: "ProfileName", actionId: "refresh", actionParam: { updateProfile: 1 },
                                    acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 }
                                }}
                            />
                            <FormSH formObject={formObject} headerKey="sharedFields" action={{
                                actionId: "new", paramName: "profile",
                                actionName: "proComp", actionParam: {}, containerKey: "popup"
                            }} >
                            </FormSH>
                        </li>
                    </ul>
                </UiCol>
            </UiGridColTwo>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <SarasTrans value="Locations" />
                    </UiTitle>
                    <UiAction>
                        <FormButton formObject={formObject} rowKey="" className="uiActionButton" starIcon="adds"
                            action={{ actionId: 'new', actionParam: {}, containerKey: 'row' }}
                            text={<SarasTrans value="Add Location" />} />
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <div style={{ overflowX: 'auto' }}>
                        <ul className="uiListTable uiProductionTable" style={{ minWidth: '795px' }}>
                            <li className="uiSearchHeading">
                                <ul>
                                    <li className="uiColumnLeft uiColumn100"><SarasTrans value="Sheet ID" /></li>
                                    <li className="uiColumnLeft" style={{ width: '185px' }}><SarasTrans value="Location" /></li>
                                    <li className="uiColumnLeft uiColumn50"><SarasTrans value="Unit" /></li>
                                    <li className="uiColumnRight uiColumnQty"><SarasTrans value="Quantity" /></li>
                                    <li className="uiColumnRight uiColumnQty"><SarasTrans value="Linked Qty" /></li>
                                    <li className="uiColumnLeft" style={{ width: '220px' }}><SarasTrans value="Comment" /></li>
                                    <li className="uiColumnCenter uiColumn100"><SarasTrans value="Action" /></li>
                                </ul>
                            </li>
                            {Object.values(viewData).map(row => (
                                <li key={row.rowKey}>
                                    <BudgetHeaderLocationWiseRow formObject={formObject}
                                        rowKey={row.rowKey} viewData={row} />
                                </li>
                            ))}
                            <li>
                                <ul className="uiDPEditLine">
                                    <li className="uiColumnLeft uiColumn100" />
                                    <li className="uiColumnLeft" style={{ width: '185px' }}><SarasTrans value="Total Quantity" /></li>
                                    <li className="uiColumnLeft uiColumn50">
                                    </li>
                                    <li className="uiColumnRight uiColumnQty">
                                        <div>
                                            <FormROValue formObject={formObject} headerKey="sharedFields"
                                                action={{ paramName: 'totalQty1' }} className="uiHighlightKey" />
                                        </div>
                                        <FormWrapper formObject={formObject} headerKey="sharedFields"
                                            action={{ paramName: 'totalQty2' }} customWrapper="div">
                                            <FormROValue formObject={formObject} headerKey="sharedFields"
                                                action={{ paramName: 'totalQty2' }} className="uiHighlightKey" />
                                        </FormWrapper>
                                    </li>
                                    <li className="uiColumnRight uiColumnQty">
                                        <div>
                                            <FormROValue formObject={formObject} headerKey="sharedFields"
                                                action={{ paramName: 'totalLinkedQty1' }} className="uiHighlightKey" />
                                        </div>
                                        <FormWrapper formObject={formObject} headerKey="sharedFields"
                                            action={{ paramName: 'totalLinkedQty2' }} customWrapper="div">
                                            <FormROValue formObject={formObject} headerKey="sharedFields"
                                                action={{ paramName: 'totalLinkedQty2' }} className="uiHighlightKey" />
                                        </FormWrapper>
                                    </li>
                                    <li className="uiColumnLeft" style={{ width: '220px' }} />
                                    <li className="uiColumnCenter uiColumn100" />
                                </ul>
                            </li>
                        </ul>
                    </div>
                </UiViewContent>
            </UiView>
        </FormDialog>
    );
};

export default withView(BudgetHeaderLocationWiseEditor, 'budgetHeader', 'budgetHeader');
